// extracted by mini-css-extract-plugin
export default {"root":"Footer-root--wG4Ma","content":"Footer-content--oFO85"};